import React from "react";
import "react-loading-skeleton/dist/skeleton.css";
import SkeletonPost from "./SkeletonPost";
import SkeletonSearchList from "./SkeletonSearchList";
import SkeletonNotificationItem from "./SkeletonNotificationItem";
import SkeletonEvent from "./SkeletonEvent";
import SkeletonVault from "./SkeletonVault";
import SkeletonTable from "./SkeletonTable";
import SkeletonSusbscription from "./SkeletonSusbscription";
import SkeletonCardManagement from "./SkeletonCardManagement";
import CustomLoader from "../custom/CustomLoader";
import SkeletonThreadList from "./SkeletonThreadList";
import SkeletonChat from "./SkeletonChat";
import SkeletonChatFanList from "./SkeletonChatFanList";
import SkeletonConversation from "./SkeletonConversation";
import SkeletonBox from "./SkeletonBox";
import SkeletonComments from "./SkeletonComments";
import SkeletonEarningTable from "./SkeletonEarningTable";
import SkeletonRefferalList from "./SkeletonRefferalList";
import SkeletonLiveStreamComment from "./SkeletonLiveStreamComment";
import SkeletonViewChatMedia from "./SkeletonViewChatMedia";
import SkeletonPhotoLibrary from "./SkeletonPhotoLibrary";
import SkeletonStory from "./SkeletonStory";

const SkeletonLoading = ({
  type,
  count = 20,
  rows = 20,
  col = 6,
  height = undefined,
  width = undefined,
  borderRadius = undefined,
}) => {
  switch (type) {
    case "post":
      return <SkeletonPost count={count} />;

    case "searchList":
      return <SkeletonSearchList count={count} />;

    case "notificationItem":
      return <SkeletonNotificationItem count={count} />;

    case "event":
      return <SkeletonEvent count={count} />;

    case "vault":
      return <SkeletonVault count={count} />;

    case "box":
      return (
        <SkeletonBox
          count={count}
          height={height}
          width={width}
          borderRadius={borderRadius}
        />
      );

    case "viewChatMedia":
      return (
        <SkeletonViewChatMedia
          count={count}
          height={height}
          width={width}
          borderRadius={borderRadius}
        />
      );

    case "table":
      return <SkeletonTable rows={rows} col={col} width={width} />;

    case "subscription":
      return <SkeletonSusbscription count={count} />;

    case "cardManagement":
      return <SkeletonCardManagement count={6} />;

    case "threadList":
      return <SkeletonThreadList count={count} />;

    case "chats":
      return <SkeletonChat count={count} />;

    case "chatFanList":
      return <SkeletonChatFanList count={count} />;

    case "conversation":
      return <SkeletonConversation count={count} />;

    case "comments":
      return <SkeletonComments count={count} />;

    case "earningTable":
      return <SkeletonEarningTable count={count} />;

    case "refferalList":
      return <SkeletonRefferalList count={count} />;

    case "liveStreamComment":
      return <SkeletonLiveStreamComment />;

    case "photoLibrary":
      return <SkeletonPhotoLibrary count={count} />;

    case "story":
      return <SkeletonStory count={count} />;

    default:
      return (
        <div className="noContentFound text-center">
          <CustomLoader />
        </div>
      );
  }
};

export default SkeletonLoading;
